/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

import React from 'react';

import { jsx } from '@compiled/react';
import ReactDOM from 'react-dom';

import { LinkItem } from '@atlaskit/menu';
import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { DropIndicator as DropIndicatorUI } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { TAB_ANGLE } from '@atlassian/navigation-kit-common';

import type { TabDragState } from '../../../types';
import { isSafari } from '../../utils';

const DropIndicator = ({ closestEdge }: { closestEdge?: Edge | null }) =>
	closestEdge ? (
		<div data-testid="navigation-kit-ui-tab-common.ui.after-elements-more-item.drag-indicator">
			<DropIndicatorUI edge={closestEdge} />
		</div>
	) : null;

export const DragPreview = ({
	elemBefore,
	elemAfter,
	name,
}: {
	closestEdge?: Edge | null;
	dragState?: TabDragState;
	elemAfter?: React.ReactNode;
	elemBefore?: React.ReactNode;
	name: React.ReactNode;
}) => (
	<Box xcss={[previewStyles, !isSafari() && tiltStyles]}>
		{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid -- See https://go/a11y-anchor-is-valid for more details */}
		<LinkItem iconBefore={elemBefore} iconAfter={elemAfter}>
			<span>{name}</span>
		</LinkItem>
	</Box>
);

const AfterElementsMoreItem = ({
	elemBefore,
	elemAfter,
	closestEdge,
	dragState,
	name,
}: {
	closestEdge?: Edge | null;
	dragState?: TabDragState;
	elemAfter?: React.ReactNode;
	elemBefore?: React.ReactNode;
	name: React.ReactNode;
}) => (
	<>
		<DropIndicator closestEdge={closestEdge} />
		{dragState && dragState.type === 'preview'
			? ReactDOM.createPortal(
					<DragPreview elemBefore={elemBefore} elemAfter={elemAfter} name={name} />,
					dragState.container,
				)
			: null}
	</>
);

const tiltStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	rotate: `${TAB_ANGLE}deg`,
});

const previewStyles = xcss({
	backgroundColor: 'elevation.surface',
});

export default AfterElementsMoreItem;
